import { AsyncPipe, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiAccessDeniedComponent } from "./new-ui-access-denied.component";

@Component({
  selector: "app-access-denied",
  templateUrl: "./access-denied.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, RouterLink, NgIf, Button, AsyncPipe],
})
export class AccessDeniedComponent extends NewUiAccessDeniedComponent {}
